import { createBrowserHistory } from "history";

/**
 * @function history
 * @desc This handles createBrowserHistory
 */
export const history = createBrowserHistory();
